export const shouldStartSearching = (value: string) => {
  return value.length > 1
}
